<template>
  <div style="padding: 20px 0px 0px 20px;">

    <el-form style="display: flex;flex-wrap: wrap;" >


      <el-form-item label="所在地域:"  style="display: flex;width: 33%;">
            <el-select v-model="input5" clearable filterable placeholder="请选择所在地域"  style="width: 100%;">
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
           </el-select>
      </el-form-item>

      <el-form-item label="扩科教师:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择老师" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList11" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="课程:" style="display: flex;width: 33%;" >
              <el-select   placeholder="请选择课程"  v-model="input3" style="width: 100%"  clearable  filterable>
                 <el-option  v-for="item in getStudentsArr_s"  :key="item.id"   :value="item.id"  :label="item.categoryName" >  </el-option>
              </el-select>
      </el-form-item>


      <el-form-item label="上课教师:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择上课教师" v-model="input111" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="已上课节数:" style="display: flex;width: 33%;">
        <el-input v-model="input333" placeholder="请输入已上课节数"></el-input>
      </el-form-item>

      <el-form-item label="学生:"  style="display: flex;width: 33%;" >
           <el-select placeholder="请选择学生" v-model="value1"  style="width: 100%"  clearable   filterable >
               <el-option   v-for="item in valueList1"  :key="item.id"  :value="item.id"  :label="item.realname">  </el-option>
           </el-select>
      </el-form-item>


      <!-- <el-form-item label="部门:" style="display: flex;width: 33%;">
        <el-select style="width: 100%" v-model="resumeNumber3" popper-class="tree-select-popper"  ref="treeSelect">
            <el-option hidden :value="resumeNumber3"> </el-option>
            <el-tree
                :data="dataTrees"
                :props="defaultPropss"
                node-key="deptId"
                ref="treeSelect"
                :highlight-current="true"
                :check-on-click-node="true"
                @check="handleTreeCheck">
            </el-tree>
        </el-select>
      </el-form-item> -->


     

      <el-form-item label="奖励情况:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择奖励情况" v-model="input33" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1111" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="达标情况:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择达标情况" v-model="input333333" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1111111" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>
<!-- 
      <el-form-item label="学科组:" style="display: flex;width: 33%;">
        <el-select v-model="SubjectGroup" clearable filterable placeholder="请选择学科组"  style="width: 100%;">
          <el-option v-for="item in SubjectGroupList" :key="item.id" :label="item.teacherName"  :value="item.id"></el-option>
        </el-select>    
      </el-form-item> -->

      <el-form-item label="创建时间:" style="display: flex;width: 45%;">
        <el-date-picker v-model="input2" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>


      <el-form-item label="奖励日期:" style="display: flex;width: 45%;">
        <el-date-picker v-model="input3333" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>



<!--  <el-form-item label="项目名称:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item> -->


      <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
        <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus"  @click="searchAddBtns">添加</el-button>、 -->
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"   @click="searchBtns">搜索</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"   @click="clearBtns">清空</el-button>
      </div>

    </el-form>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700">
      <el-table-column prop="regionNames" label="所在地域" show-overflow-tooltip></el-table-column>
      <el-table-column prop="expandTeacherName" label="扩科教师" show-overflow-tooltip></el-table-column>
      <el-table-column prop="categoryName" label="课程" show-overflow-tooltip></el-table-column>
      <el-table-column prop="teacherName" label="上课教师" show-overflow-tooltip></el-table-column>
      <el-table-column prop="studentName" label="学生" show-overflow-tooltip></el-table-column>
      <el-table-column prop="classNum" label="已上课节数" show-overflow-tooltip  width="100"></el-table-column>
      <el-table-column prop="isReach" label="达标情况" show-overflow-tooltip>
        <template v-slot="scope">
          <div v-if="scope.row.isReach === 2">已达标</div>
          <div v-else>未达标</div>
        </template>
      </el-table-column>
      <el-table-column prop="awardType" label="奖励情况" show-overflow-tooltip>
        <template v-slot="scope">
          <div  v-if="scope.row.awardType === 1">否</div>
          <div  v-if="scope.row.awardType === 2">是</div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip width="170"></el-table-column>
      <el-table-column prop="awardTime" label="奖励日期" show-overflow-tooltip width="110"></el-table-column>

      <el-table-column label="操作" fixed="right" width="200">
        <template v-slot="scope">
          <div style="display: flex;justify-content: space-around;">
            <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">查看</el-button>
            <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button>
            <!-- <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">删除</el-button> -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>

    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" :title="Titlecenter === '积分详情' ? '详情' : '编辑'" :visible="addShow" :before-close="closeEditDialog" width="80%">

      <el-form style="display: flex;flex-wrap: wrap;">
        <el-form-item label="奖励情况:" style="display: flex;width: 33%;">
          <el-select placeholder="请选择项目名称" v-model="value11" style="width: 100%" clearable filterable :disabled="Titlecenter === '积分详情' ? true : false">
            <el-option v-for="item in optionList1111" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="奖励日期:" style="display: flex;width: 60%;" >
          <el-date-picker v-model="value22" type="date" value-format="yyyy-MM-dd"  clearable :disabled="Titlecenter === '积分详情' ? true : false">
          </el-date-picker>
        </el-form-item>

      </el-form>



      <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" :data="dataList1" border height="700" >
        <el-table-column prop="categoryName" label="课程" show-overflow-tooltip></el-table-column>
        <el-table-column prop="courseDate" label="日期" show-overflow-tooltip></el-table-column>
        <el-table-column prop="courseTimeOn" label="开始时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="courseEndTime" label="结束时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="teacherName" label="老师" show-overflow-tooltip></el-table-column>
        <el-table-column prop="educationType" label="上课方式" show-overflow-tooltip>
          <template v-slot="scope">
            <div  v-if="scope.row.educationType === 1">网课</div>
            <div  v-if="scope.row.educationType === 2">上门</div>
            <div  v-if="scope.row.educationType === 3">门店</div>
          </template>
        </el-table-column>
        <el-table-column prop="classEnding" label="节课状态" show-overflow-tooltip>
          <template v-slot="scope">
            <div  v-if="scope.row.classEnding === 1">结课</div>
            <div  v-if="scope.row.classEnding === 2">未结课</div>
          </template>
        </el-table-column>
        <el-table-column prop="productClassType" label="班型" show-overflow-tooltip>
          <template v-slot="scope">
            <div  v-if="scope.row.productClassType === 1">1V1</div>
            <div  v-if="scope.row.productClassType === 2">1V2</div>
            <div  v-if="scope.row.productClassType === 3">1V3</div>
          </template>
        </el-table-column>
        <el-table-column prop="classPersonType" label="上课人员" show-overflow-tooltip>
          <template v-slot="scope">
            <div  v-if="scope.row.classPersonType === 1">孩子</div>
            <div  v-if="scope.row.classPersonType === 2">孩子和父亲</div>
            <div  v-if="scope.row.classPersonType === 3">孩子和母亲</div>
            <div  v-if="scope.row.classPersonType === 4">父亲</div>
            <div  v-if="scope.row.classPersonType === 5">母亲</div>
            <div  v-if="scope.row.classPersonType === 6">父亲和母亲</div>
            <div  v-if="scope.row.classPersonType === 7">孩子、父亲、母亲</div>
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-form-item label="审批时间:" style="display: flex;width: 60%;">
        <el-date-picker v-model="value3" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>

    </el-form> -->

  <!--   <div style="margin: 20px 0px 0px 0px;">积分总数：<span style="color:red;">{{  integralCount }}</span></div>


    <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
      <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"  @click="searchBtns1">搜索</el-button>
      <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns1">清空</el-button>
    </div>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" :data="dataList1" border height="700">
      <el-table-column prop="teacherName" label="教师名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralName" label="积分项目" show-overflow-tooltip></el-table-column>
      <el-table-column prop="applyForIntegral" label="分数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="secondAuditDate" label="审批时间" show-overflow-tooltip></el-table-column>
    </el-table>

    <el-pagination style="text-align: center; margin: 20px;" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNum1"
      :page-size="pageSize1" layout="prev, pager, next,sizes, jumper" :total="total1">
    </el-pagination> -->


    <div style="display: flex; margin-bottom: 20px; justify-content: end; margin-top: 20px;">
      <el-button  type="primary" size="small" class="btns" v-if="Titlecenter === '积分详情' ? false : true"   @click="handleClickViewBtn('确定')">确定</el-button>
      <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('取消')">取消</el-button>
    </div>


    </el-dialog>

  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getTeachers, getSubject} from "@/api/fiveClassApi"
import {
  ApiGetStudentList,
} from "@/api/apiTask";

export default {
  components: {

  },
  data() {
    return {

      SubjectGroupList: [],
      SubjectGroup: '',
      value1: '',
      value2: [],
      value3: [],
      input5:'',
      integralCount: 0,
      input3333:[],

      input33:'',
      input333:'',

      value22:'',
      value11:'',

      inputValue1: '',
      inputValue2: 0 ,
      inputValue3: '',

      Titlecenter: '添加积分项目',
      optionList4: [{ id: 0, name: '无效' }, { id: 1, name: '有效' }],

      optionList1: [],
      optionList11: [],
      optionList2: [],
      optionList3: [{ id: 0, name: '待审批' }, { id: 1, name: '驳回' }, { id: 2, name: '已完成' }],
      optionList1111: [{ id: 2, realname: '是' }, { id: 1, realname: '否' }],
      optionList1111111: [{ id: 1, realname: '未达标' }, { id: 2, realname: '已达标' }],
      input333333: '',
      input1: '',
      input2: [],
      input3: '',

      dataList: [],

      pageNum: 1,
      pageSize: 10,
      total: 0,
      input111: [],

      pageNum1: 1,
      pageSize1: 10,
      total1: 0,

      CourseCancellationComponentsType: '',
      CourseCancellationComponentsID: '',
      CourseCancellationComponentsShow: false,

      CourseCancellationomponentsTypeDistinguish: '课消审批',

      dataList1:[],


      addShow: false,

      inputID:'',

      optionList5:[],
      teacherIditme:null,


      resumeNumber3Id:'',
      resumeNumber3:'',

      dataTrees:[],
      defaultPropss:{ children: 'children', label: 'deptName' },

      optionsListt:[],
      getStudentsArr_s:[],

      valueList1: [],



    }
  },

  mounted() {
    this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))
    // getTeachers().then(res => { this.optionList1 = res.data })
    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.optionList2 = res.data.data })
    axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})
    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionsListt = res.data.data})
    getSubject().then(res => { this.getStudentsArr_s = res.data  })

    ApiGetStudentList().then((res) => {  let { data } = res; this.valueList1 = data;  });


    this.getApiList()
    this.handleintegralProject()

    axios.get(`${apiBaseUrl}/expand/findTeacherList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
      this.optionList1 = res.data.data
    })
    axios.get(`${apiBaseUrl}/expand/findExpandTeacherList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
      this.optionList11 = res.data.data
    })

  },



  methods: {


    handleTreeCheck(e){
      this.resumeNumber3 = e.deptName
      this.resumeNumber3Id = e.deptId
      this.$refs.treeSelect.visible = false
    },

    handleintegralProject(){
      axios.post(`${apiBaseUrl}/integralProject/findList`, { integralName:'' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.optionList5 = data
        } else {
          this.optionList5 = []
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleClickViewBtn(type){

      if(type === '取消'){
          this.inputValue1 = ''
          this.inputValue2 = 0
          this.inputValue3 = ''
          this.Titlecenter = ''
          this.inputID = ''
          this.value11 = ''
          this.value22 = ''
          this.addShow = false
      }

      if(type === '确定'){

        if(this.value11 === ''){
           this.$message.warning('请选择奖励情况~')
          return
        }

        if(this.value22 === ''){
           this.$message.warning('请选择奖励情况~')
          return
        } 

        let data = { awardType: this.value11,  awardTime: this.value22,  id: this.inputID,  }

        axios.post(`${apiBaseUrl}/expand/update`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
          if (res.data.code === 200) {
            this.inputValue1 = ''
            this.inputValue2 = 0
            this.inputValue3 = ''
            this.Titlecenter = ''
            this.inputID = ''
            this.value11 = ''
            this.value22 = ''
            this.addShow = false
            this.getApiList1()   
          } else {
          }
        }).catch((err) => {
          this.$message.error(err)
        })
        
      }

    },

    searchAddBtns() {
      this.Titlecenter = '添加积分项目'
      this.addShow = true
    },

    closeEditDialog() {
      this.Titlecenter = ''
      this.inputValue1 = ''
      this.inputValue2 = 0
      this.inputValue3 = ''
      this.inputID = ''

      this.value1 = ''
      this.value2 = []
      this.value3 = []

      this.addShow = false
    },

    CourseCancellationhandleEmit(e) {
      this.CourseCancellationComponentsShow = e
    },

    searchBtns() {
      this.getApiList()
    },

    searchBtns1() {
      this.getApiList1()
    },

    clearBtns1() {
      this.value1 = ''
      this.value2 = []
      this.value3 = []
      this.getApiList1()
    },


    clearBtns() {
      this.SubjectGroup = ''
      this.input1 = ''
      this.input2 = []
      this.input3 = ''
      this.input4 = ''
      this.input33 = ''
      this.input3333 = []
      this.input333 = ''
      this.resumeNumber3 = ''
      
      this.input5 = ''
      this.input111 = ''
      this.value1 = ''
      this.input333333 = ''

      this.pageNum = 1
      this.pageSize = 10


      this.getApiList()
    },

    exportBtns(){
      let data = {
        regionName: this.input5,
        expandTeacherId: this.input1,
        categoryId: this.input3,
        teacherId: this.input111,
        classNum: this.input333 ? Number(this.input333) : '',
        studentId: this.value1,
        awardType: this.input33,
        createTimeStart: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        createTimeEnd: (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 23:59:59' : null,
        awardTimeStart: (this.input3333 && this.input3333.length > 0) ? this.input3333[0] : null,
        awardTimeEnd: (this.input3333 && this.input3333.length > 0) ? this.input3333[1] : null,

        isReach: this.input333333,
        // integralId: this.value1,
      }
      axios.post(`${apiBaseUrl}/expand/export`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
           if(response.status == 200){
               const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
               const downloadLink = document.createElement("a")
               downloadLink.href = URL.createObjectURL(blob)
               downloadLink.download = "扩科转介绍.xlsx"
               downloadLink.click()
               this.$message({ message:'导出成功', type: "success" });
           } else{
              this.$message.error('导出失败')
           }
       }).catch((err) => {
          this.$message.error(err)
      })
    },


    getApiList1() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        regionName: this.input5,
        expandTeacherId: this.input1,
        categoryId: this.input3,
        teacherId: this.input111,
        classNum: this.input333 ? Number(this.input333) : '',
        studentId: this.value1,
        awardType: this.input33,
        createTimeStart: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        createTimeEnd: (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 23:59:59' : null,
        awardTimeStart: (this.input3333 && this.input3333.length > 0) ? this.input3333[0] : null,
        awardTimeEnd: (this.input3333 && this.input3333.length > 0) ? this.input3333[1] : null,

        isReach: this.input333333,

        // teacherId: this.teacherIditme.teacherId,
        // commitStartDate: (this.value2 && this.value2.length > 0) ? this.value2[0] + ' 00:00:00' : null,
        // commitEndDate: (this.value2 && this.value2.length > 0) ? this.value2[1] + ' 00:00:00' : null,
        // auditStartDate: (this.value3 && this.value3.length > 0) ? this.value3[0] + ' 00:00:00' : null,
        // auditEndDate: (this.value3 && this.value3.length > 0) ? this.value3[1] + ' 00:00:00' : null,
        // integralId: this.value1,
      }
      axios.post(`${apiBaseUrl}/expand/page`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList = data.records
          this.pageNum = data.current ? data.current : 0
          this.pageSize = data.size ? data.size : 10
          this.total = data.total ? data.total : 0

          if(data.records && data.records.length < 0){
            this.dataList = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {

          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    getApiList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        regionName: this.input5,
        expandTeacherId: this.input1,
        categoryId: this.input3,
        teacherId: this.input111,
        classNum: this.input333 ? Number(this.input333) : '',
        studentId: this.value1,
        awardType: this.input33,
        createTimeStart: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        createTimeEnd: (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 23:59:59' : null,
        awardTimeStart: (this.input3333 && this.input3333.length > 0) ? this.input3333[0] : null,
        awardTimeEnd: (this.input3333 && this.input3333.length > 0) ? this.input3333[1] : null,
        isReach: this.input333333,
      }
      axios.post(`${apiBaseUrl}/expand/page`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList = data.records
          this.pageNum = data.current ? data.current : 0
          this.pageSize = data.size ? data.size : 10
          this.total = data.total ? data.total : 0

          if(data.records && data.records.length < 0){
            this.dataList = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleSizeChange(e) {
      this.pageSize = e
      this.getApiList()
    },

    handleSizeChange1(e) {
      this.pageSize1 = e
      this.getApiList1()
    },


    handleCurrentChange(e) {
      this.pageNum = e
      this.getApiList()
    },


    handleCurrentChange1(e) {
      this.pageNum1= e
      this.getApiList1()
    },

    handleClickView(type, itme) {

      axios.post(`${apiBaseUrl}/expand/findScheduleInfo/${itme.id}`, { }, { headers: {'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList1 = data
          if (data && data.length < 0) {
            this.dataList1 = []
          }
        } else {
          this.$message.error(res.data.message)
        }
      })



      this.value11 = itme.awardType
      this.value22 = itme.awardTime
     
      this.inputID = itme.id


      if (type === '编辑') {
        console.log(itme)
        this.Titlecenter = '编辑积分项目'

        this.value11 = itme.awardType
        this.value22 = itme.awardTime
       
        this.inputID = itme.id

        this.addShow = true

      }

      if (type === '详情') {
        console.log(itme)
        this.Titlecenter = '积分详情'

        // this.inputValue1 = itme.inputValue1
        // this.inputValue2 = itme.inputValue2
        // this.inputValue3 = itme.inputValue3
        // this.inputID = itme.id

        this.teacherIditme = itme

        this.addShow = true

        // this.getApiList1()


      } else {
        this.CourseCancellationComponentsType = type
        this.CourseCancellationComponentsID = itme.id
        this.CourseCancellationComponentsShow = true

        // this.$nextTick(() => {
        //   this.$refs.CourseCancellationomponents.handleInit(itme.id)
        // })
      }

        
  
  
  





    },


  }

}
</script>


<style scoped lang="less">
.no-click {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/IntroductionToExpandingScienceAndTechnology/IntroductionToExpandingScienceAndTechnology.vue